import { z } from 'zod';
import { DOCUMENT_ID_LENGTH } from '../constants';

export const verifyTitleOwnerIncomeDocumentsSchema = z.object({
  applicationId: z.string().min(1, 'applicationId is required'),
  titleSearchOwnerId: z.string().min(1, 'titleSearchOwnerId is required'),
  documentIds: z
    .array(z.string().length(DOCUMENT_ID_LENGTH, `Document ID must be ${DOCUMENT_ID_LENGTH} characters long`))
    .min(1, 'At least one document ID is required'),
});
